/**
 * Downlink starvation: `threshold` audio underflows within `windowMs`
 * means playback cannot keep up with what the network delivers (the
 * viewer's downlink cannot carry the stream). Pure counter.
 */
export class PlaybackHealth {
    threshold;
    windowMs;
    underflows = [];
    constructor(threshold, windowMs) {
        this.threshold = threshold;
        this.windowMs = windowMs;
    }
    /** true when the window's threshold is reached (the window then restarts) */
    noteUnderflow(nowMs) {
        this.underflows.push(nowMs);
        this.underflows = this.underflows.filter((t) => nowMs - t <= this.windowMs);
        if (this.underflows.length >= this.threshold) {
            this.underflows = [];
            return true;
        }
        return false;
    }
    count() {
        return this.underflows.length;
    }
    reset() {
        this.underflows = [];
    }
}
